import { render } from "./base-preloader.vue?vue&type=template&id=8bf761ce&ts=true"
import script from "./base-preloader.vue?vue&type=script&lang=ts"
export * from "./base-preloader.vue?vue&type=script&lang=ts"

import "./base-preloader.vue?vue&type=style&index=0&id=8bf761ce&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__